import {
  ISoldItemsAllowedStores,
  ISoldItemsExportParams,
  SoldItemsExportResult,
} from "src/@types/sold-items";

import { apiSlice } from "./http";
import { toQueryParams } from "@/utils/to-query-params";

const NO_CONTENT = 204;

async function exportRequestHandler(
  response: Response,
): Promise<SoldItemsExportResult> {
  if (response.status === NO_CONTENT) {
    return {};
  }
  return response.json().catch(() => response.text());
}

export const soldItemsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSoldItemsAllowedStores: builder.query<ISoldItemsAllowedStores, void>({
      query: () => ({
        url: "/sold-items/allowed-stores",
        method: "GET",
      }),
    }),
    exportSoldItemsExcel: builder.mutation<
      SoldItemsExportResult,
      ISoldItemsExportParams
    >({
      query: (filters) => ({
        url: `/sold-items/export?${toQueryParams(filters)}`,
        method: "POST",
        responseHandler: exportRequestHandler,
      }),
    }),
    exportSoldItemsPdf: builder.mutation<
      SoldItemsExportResult,
      ISoldItemsExportParams
    >({
      query: (filters) => ({
        url: `/sold-items/export.pdf?${toQueryParams(filters)}`,
        method: "POST",
        responseHandler: exportRequestHandler,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSoldItemsAllowedStoresQuery,
  useExportSoldItemsExcelMutation,
  useExportSoldItemsPdfMutation,
} = soldItemsApi;
